<template>
  <div class="artist">
    <Header/>
    <div class="artist__menu">
      <ArtistInfo/>
    </div>
    <Rodo/>
  </div>
</template>

<script>
import Header from '@/components/Header/Mobile/Header.vue';
import ArtistInfo from '@/components/ArtistInfo/Mobile/ArtistInfo.vue';
import Rodo from '@/components/Rodo/Mobile/Rodo.vue';
import mixin from '../mixin';

export default {
  mixins: [mixin],
  components: {
    Header,
    ArtistInfo,
    Rodo
  },
  data() {
    return {
    }
  },
  mounted() {
  }
}
</script>

<style lang="scss" scoped>
  .artist {
    &__menu {
      margin-top: -17rem;
    }
  }
</style>

<style>
.home__menu {
  padding: 0 1rem;
}
</style>